import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Zap } from 'lucide-react';

export default function FooterSection() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary text-white py-12" data-testid="footer-section">
      <div className="container mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Zap className="w-6 h-6" />
          <span className="text-xl font-light" style={{ fontFamily: 'Outfit' }}>Powersure Worldwide</span>
        </div>
        <p className="text-sm text-white/80 mb-6">{t('footer.tagline')}</p>

        <nav
          className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm text-white/85 mb-5"
          aria-label={t('legal.nav.ariaLabel', 'Legal navigation')}
        >
          <Link to="/privacy" className="hover:text-white underline-offset-2 hover:underline" data-testid="footer-link-privacy">
            {t('legal.nav.privacy')}
          </Link>
          <span aria-hidden className="text-white/40">·</span>
          <Link to="/terms" className="hover:text-white underline-offset-2 hover:underline" data-testid="footer-link-terms">
            {t('legal.nav.terms')}
          </Link>
          <span aria-hidden className="text-white/40">·</span>
          <Link to="/contact" className="hover:text-white underline-offset-2 hover:underline" data-testid="footer-link-contact">
            {t('legal.nav.contact')}
          </Link>
          <span aria-hidden className="text-white/40">·</span>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event('powersure:open-cookie-prefs'))}
            className="hover:text-white underline-offset-2 hover:underline bg-transparent border-0 p-0 m-0 cursor-pointer"
            data-testid="footer-cookie-settings"
          >
            {t('legal.nav.cookieSettings')}
          </button>
          <span aria-hidden className="text-white/40">·</span>
          <a
            href="mailto:offertes@powersure-worldwide.com"
            className="hover:text-white underline-offset-2 hover:underline"
            data-testid="footer-mailto"
          >
            offertes@powersure-worldwide.com
          </a>
        </nav>

        <p className="text-xs text-white/60 max-w-xl mx-auto" data-testid="footer-affiliate-disclosure">
          {t('legal.affiliate.shortNotice')}
        </p>
        <p className="text-xs text-white/40 mt-3">&copy; {new Date().getFullYear()} Powersure Worldwide</p>
      </div>
    </footer>
  );
}
